import { render, staticRenderFns } from "./addInclude.vue?vue&type=template&id=52f87314"
import script from "./addInclude.vue?vue&type=script&lang=js"
export * from "./addInclude.vue?vue&type=script&lang=js"
import style0 from "./addInclude.vue?vue&type=style&index=0&id=52f87314&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f87314')) {
      api.createRecord('52f87314', component.options)
    } else {
      api.reload('52f87314', component.options)
    }
    module.hot.accept("./addInclude.vue?vue&type=template&id=52f87314", function () {
      api.rerender('52f87314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/addInclude.vue"
export default component.exports